import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-restrict",
  "use": "icon-restrict-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-restrict\"><g><g id=\"icon-restrict_Block_8_\"><path d=\"M27.3,4.7c-6.2-6.2-16.4-6.2-22.6,0c-6.2,6.2-6.2,16.4,0,22.6       c6.2,6.2,16.4,6.2,22.6,0C33.6,21.1,33.6,10.9,27.3,4.7z M24.5,7.5c4.2,4.2,4.6,10.7,1.3,15.4L9.1,6.2       C13.7,2.9,20.3,3.3,24.5,7.5z M7.5,24.5C3.3,20.3,2.9,13.7,6.2,9.1l16.7,16.7C18.3,29.1,11.7,28.7,7.5,24.5z\" id=\"icon-restrict_Block\" style=\"fill:#FF3939;\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol